/* import __COLOCATED_TEMPLATE__ from './request.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './request.module.scss';

export default class SignInTokenRequest extends Component {
  @service signIn;
  styles = styles;

  get shouldShowNewOrInvalidState() {
    return this.args.model.isNew && this.signIn.lastError !== 'invalidEmail';
  }

  get showAuthErrorForNewState() {
    return (
      this.args.showAuthError || (this.signIn.lastError && this.signIn.lastError !== 'invalidEmail')
    );
  }
}
